import { subspaced } from 'react-redux-subspace';
import { defaultStateHandler } from '@redux-dynostore/core';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var subspacedEnhancer = function subspacedEnhancer(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      stateHandler = _ref2.stateHandler,
      _ref2$mapExtraState = _ref2.mapExtraState,
      mapExtraState = _ref2$mapExtraState === void 0 ? function () {
    return null;
  } : _ref2$mapExtraState,
      subspaceOptions = _objectWithoutPropertiesLoose(_ref2, ["stateHandler", "mapExtraState"]);

  return function (identifier) {
    return function (store) {
      var defaultOptions = store.dynostoreOptions || {};

      var _ref3 = stateHandler || defaultOptions.stateHandler || defaultStateHandler,
          getValue = _ref3.getValue,
          canMerge = _ref3.canMerge,
          merge = _ref3.merge;

      var mapState = function mapState(state, rootState) {
        var componentState = getValue(state, identifier);

        if (!canMerge(componentState)) {
          return componentState;
        }

        var extraState = mapExtraState(state, rootState);

        if (!canMerge(extraState)) {
          if (process.env.NODE_ENV !== 'production' && extraState !== null) {
            throw new TypeError("extra state must be a mergable with the component state but received " + extraState);
          }

          return componentState;
        }

        return merge(extraState, componentState);
      };

      var subspaceEnhancer = subspaced(mapState, identifier, subspaceOptions);
      return function (Component) {
        return subspaceEnhancer(Component);
      };
    };
  };
};

export default subspacedEnhancer;
